import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Form, Row, Button, Table, Card } from 'react-bootstrap';
// import { paymentDetailsAction, paymentHeaderAction } from 'actions';
import { Link } from 'react-router-dom';
import Flex from 'components/common/Flex';
import Moment from "moment";
import {  clientListAPI } from 'actions/ClientRegistration/ClientRegistrationAction.js';
import { clientReportDataAction, clientReportDetailAPI, clientReportPdfAPI } from 'actions/ClientReport/clientReportAction.js';
import { getClientCaseMasterListAPI } from 'actions/CaseNextDate/caseNextDateAction.js';
import { toast } from 'react-toastify';
import TablePagination from 'components/common/TablePagination.js';
import loader from '../../assets/img/loader.svg'

const ClientSOADetails = () => {

	const [perPage, setPerPage] = useState(5);
	let token = localStorage.getItem('Token') || sessionStorage.getItem('Token');
	const [clientList, setClientList] = useState([]);
	const [clientDetail, setClientDetail] = useState([]);
	const [clientCaseMasterList, setClientCaseMasterList] = useState([]);
	const [clientCaseDetail, setClientCaseDetail] = useState();
	const [isLoading, setIsLoading] = useState(false);
	const [caseReportList, setCaseReportList] = useState([]);
	const [paymentReportList, setPaymentReportList] = useState([]);
	const [mergedPaymentAndCaseList, setMergedPaymentAndCaseList] = useState([]);
	const [mergedList, setMergedList] = useState([]);
	const [pageNumber, setPageNumber] = useState(1);
	const [pageSize, setPageSize] = useState(5);
	const [caseReportCount, setCaseReportCount] = useState(0);
	const [paymentReportCount, setPaymentReportCount] = useState(0);
	const [totalAmount, setTotalAmount] = useState(0);

	const [formHasError, setFormError] = useState(false);
	const selectedClientCode = localStorage.getItem('ClientCode');
	let pageCount = Math.ceil(caseReportCount / pageSize);
	const isPreviousDisabled = pageNumber === 1;
	const isNextDisabled = pageNumber === pageCount;
	const headers = {
		Authorization: `Bearer ${JSON.parse(token).value}`
	};
	const dispatch = useDispatch();
	const resetClientSOADetails = () => {
		dispatch(clientReportDataAction({
			//   "fromDate":  Moment().format('YYYY-MM-DD'),
			//   "toDate":  Moment().format('YYYY-MM-DD'),
			"reportType": "Summary",
			"clientCode": "",
			"clientCaseNo": "",
		}))
	}

	const clientReportReducer = useSelector((state) => state.rootReducer.clientReportReducer)
	var clientReportData = clientReportReducer.clientReportData;
	if (
		!clientReportReducer.clientReportData ||
		Object.keys(clientReportReducer.clientReportData).length <= 0
	) {
		resetClientSOADetails();
	}

	useEffect(() => {
		$('#btnSave').hide();
		getClientList();
	}, [])

	useEffect(() => {
		$('#btnSave').hide();
		if (mergedList && mergedList.length > 0) {
			const mergedData = mergeRowsByClientCaseNoLineName(mergedList);
			setMergedPaymentAndCaseList(mergedData);
		} else {
			setMergedPaymentAndCaseList([]);
		}

	}, [mergedList])
	const mergeRowsByClientCaseNoLineName = (list) => {
		const groupedByClientCaseNo = {};
		list.forEach((item) => {
			const key = `${item.clientCode}`;

			if (!groupedByClientCaseNo[key]) {
				groupedByClientCaseNo[key] = [item];
			} else {
				groupedByClientCaseNo[key].push(item);
			}
		});

		const mergedList = Object.values(groupedByClientCaseNo);
		return mergedList;
	};

	const getClientList = async (searchText) => {
		const data = {
			pageNumber: 1,
			pageSize: 1,
			SearchText: searchText ? searchText : '',
			EncryptedAdvocateCode: localStorage.getItem('EncryptedAdvocateCode'),
			isDropDown: true
		};
		dispatch(
			clientListAPI(
				data,
				res => {
					if (res.data.data.clientList.length > 0)
						setClientList(res.data.data.clientList);
					setClientDetail(res.data.data.clientList)
				},
				err => {
					setClientList([]);
					console.log(err?.data.message);
				},
				headers
			)
		);
	};

	const ClientReportPDF = async (newPageNumber, newPageSize, clientCode, caseNo, reportType, fromDate, toDate) => {
		if ((clientValidation())) {
			let requestData = {
				EncryptedAdvocateCode: localStorage.getItem("EncryptedAdvocateCode"),
				ClientCode: clientCode ? clientCode : localStorage.getItem("ClientCode") ? localStorage.getItem("ClientCode") : clientReportData.clientCode != null || "" ? clientReportData.clientCode : "",
				ReportType: reportType ? reportType : "Summary",
				ClientCaseNo: caseNo ? caseNo : localStorage.getItem("ClientCaseNo") ? localStorage.getItem("ClientCaseNo") : clientReportData.clientCaseNo ? clientReportData.clientCaseNo : "",
				PageNumber: newPageNumber ? newPageNumber : pageNumber,
				PageSize: newPageSize ? newPageSize : pageSize,
				FromDate: fromDate ? fromDate : clientReportData.fromDate ? Moment(clientReportData.fromDate).format("YYYY-MM-DD") : Moment().format("YYYY-MM-DD"),
				ToDate: toDate ? toDate : clientReportData.toDate ? Moment(clientReportData.toDate).format("YYYY-MM-DD") : Moment().format("YYYY-MM-DD"),
				isGeneratePDF: true,
			}

			await dispatch(
				clientReportPdfAPI(
					requestData,
					(res) => {
						console.log(res);
					},
					(err) => {
						console.error("Error occurred while generating PDF:", err?.message || err);
					},
					headers
				)
			);
		}
	}
	const getClientReportList = async (newPageNumber, newPageSize, clientCode, caseNo, reportType, fromDate, toDate) => {
		// if (caseClientReportValidation()) {		
		let requestData = {
			EncryptedAdvocateCode: localStorage.getItem("EncryptedAdvocateCode"),
			ClientCode: clientCode ? clientCode : localStorage.getItem("ClientCode") ? localStorage.getItem("ClientCode") : clientReportData.clientCode != null || "" ? clientReportData.clientCode : "",
			ReportType: reportType ? reportType : "Summary",
			ClientCaseNo: caseNo ? caseNo : localStorage.getItem("ClientCaseNo") ? localStorage.getItem("ClientCaseNo") : clientReportData.clientCaseNo ? clientReportData.clientCaseNo : "",
			PageNumber: newPageNumber ? newPageNumber : pageNumber,
			PageSize: newPageSize ? newPageSize : pageSize,
			FromDate: fromDate ? fromDate : clientReportData.fromDate ? Moment(clientReportData.fromDate).format("YYYY-MM-DD") : Moment().format("YYYY-MM-DD"),
			ToDate: toDate ? toDate : clientReportData.toDate ? Moment(clientReportData.toDate).format("YYYY-MM-DD") : Moment().format("YYYY-MM-DD"),
			isGeneratePDF: false,
		}
		setIsLoading(true);
		await dispatch(
			clientReportDetailAPI(
				requestData,
				res => {
					if (res.data.status == 200) {
						setIsLoading(false);
						setCaseReportList(res.data.data.caseReport)
						setCaseReportCount(res.data.data.caseReport.reportCount)
						setPaymentReportList(res.data.data.paymentReport)
						setPaymentReportCount(res.data.data.paymentReport.paymentReportCount)
						setTotalAmount(res.data.data.paymentReport.totalAmount || res.data.data.paymentReport.clientTotalAmount)
						setMergedList(res.data.data.mergedList)

					} else {
						setIsLoading(false);
						setCaseReportList([])
						setCaseReportCount(0)
						setPaymentReportList([])
						setPaymentReportCount(0)
						setTotalAmount(0)
						setMergedList([])
						setTimeout(function () {
							$('#no-case-schedule-message').html('No records found!');
						}, 100)
					}
				},
				err => {
					setTimeout(function () {
						$('#no-case-schedule-message').html('No records found!');
					}, 100)
						  toast.error(err?.data?.message , {
							  theme: 'colored',
							  autoClose: 10000,
							});
					console.log(err?.data.message);
				},
				headers
			)
		);
		// }
	}

	const handleClientSearchOnChange = (e) => {
		if (e.target.value) {

			const searchText = e.target.value;
			const regex = new RegExp(searchText, 'i');
			const filteredList = clientList && clientList.filter(data => regex.test(data.clientName));
			setClientDetail(filteredList);
		}
		else {
			setClientDetail(clientList)
		}
	}
	const handleClientCaseSearchOnChange = (e) => {
		if (e.target.value) {

			const searchText = e.target.value;
			const regex = new RegExp(searchText, 'i');
			const filteredList = clientCaseMasterList && clientCaseMasterList.filter(data =>
				regex.test(`${data.caseNo} - ${data.caseTitle}`)
			);

			setClientCaseDetail(filteredList);
		}
		else {
			setClientCaseDetail(clientCaseMasterList)
		}
	}
	const getClientCaseMasterList = async (clientCode) => {
		const data = {
			EncryptedAdvocateCode: localStorage.getItem('EncryptedAdvocateCode'),
			ClientCode: clientCode ? clientCode : selectedClientCode
		};
		await dispatch(
			getClientCaseMasterListAPI(
				data,
				res => {
					if (res.data && res.data.data.caseMasterList.length > 0) {
						setClientCaseMasterList(res.data.data.caseMasterList);
						setClientCaseDetail(res.data.data.caseMasterList);
					} else {
						setClientCaseMasterList([]);
						setClientCaseDetail([]);
					}
				},
				err => {
					setClientCaseMasterList([]);
				},
				headers
			)
		);
	};
	const clientValidation = () => {
		let isValid = true;

		if (!clientReportData.clientCode) {
			toast.error("Please select client first", {
				theme: 'colored',
				autoClose: 5000
			});
			return
		}
		if (clientReportData.fromDate > clientReportData.toDate) {
			toast.error("From Date cannot be greater than To Date", {
				theme: 'colored'
			});
			isValid = false;
			setFormError(true);
		}
		return isValid;
	};

	const handleClientReport = async (clientCode, clientCaseNo, reportType) => {
		dispatch(clientReportDataAction({
			...clientReportData,
			clientCode: clientCode,
			clientCaseNo: clientCaseNo,
		}))
		getClientCaseMasterList(clientCode)
		getClientReportList(1, perPage, clientCode || clientReportData.clientCode, clientCaseNo, reportType);
	}
	const handleFieldChange = (e, clientCode, clientCaseNo, reportType, name) => {
		if (clientCode && name == "clientCode") {
			dispatch(
				clientReportDataAction({
					...clientReportData,
					clientCode: clientCode,
					clientCaseNo: null
				})
			);
			getClientCaseMasterList(clientCode)
			getClientReportList(1, perPage, clientCode, "", e.target.value, clientReportData.fromDate, clientReportData.toDate)
		}
		else if (clientCaseNo && name == "clientCaseNo") {
			dispatch(
				clientReportDataAction({
					...clientReportData,
					clientCaseNo: clientCaseNo
				})
			);
			getClientReportList(1, perPage, clientCode, clientCaseNo, reportType || e.target.value, clientReportData.fromDate, clientReportData.toDate)
		}
		if ((clientReportData.clientCode || clientCode) && e.target.name == "reportType") {
			dispatch(
				clientReportDataAction({
					...clientReportData,
					reportType: e.target.value
				})
			);
			getClientReportList(1, perPage, clientReportData.clientCode, clientReportData.clientCaseNo, e.target.value, clientReportData.fromDate, clientReportData.toDate)
		}
		else if (e.target.name == "fromDate") {
			dispatch(
				clientReportDataAction({
					...clientReportData,
					fromDate: e.target.value
				})
			);
			if((clientReportData.clientCode || clientCode)){
				getClientReportList(1, perPage, clientReportData.clientCode, clientReportData.clientCaseNo, clientReportData.reportType, e.target.value, clientReportData.toDate)
			}
		}
		else if (e.target.name == "toDate") {
			dispatch(
				clientReportDataAction({
					...clientReportData,
					toDate: e.target.value
				})
			);
			if((clientReportData.clientCode || clientCode)){
				getClientReportList(1, perPage, clientReportData.clientCode, clientReportData.clientCaseNo, clientReportData.reportType, clientReportData.fromDate, e.target.value)
			}
		}
	}

	const onPageClick = async ({ selected }) => {
		setPageNumber(selected + 1);
		getClientReportList(selected + 1, perPage, clientReportData.clientCode, clientReportData.clientCaseNo, clientReportData.reportType, clientReportData.fromDate, clientReportData.toDate)
	}
	const handlePageSize = async (e) => {
		setPageSize(e.target.value);
		setPageNumber(1);
		getClientReportList(1, e.target.value, clientReportData.clientCode, clientReportData.clientCaseNo, clientReportData.reportType, clientReportData.fromDate, clientReportData.toDate)
	}

	const handlePreviousClick = async () => {
		setPageNumber(pageNumber - 1);
		getClientReportList(pageNumber - 1, perPage, clientReportData.clientCode, clientReportData.clientCaseNo, clientReportData.reportType, clientReportData.fromDate, clientReportData.toDate)
	}

	const handleNextClick = async () => {
		setPageNumber(pageNumber + 1);
		getClientReportList(pageNumber + 1, perPage, clientReportData.clientCode, clientReportData.clientCaseNo, clientReportData.reportType, clientReportData.fromDate, clientReportData.toDate)
	}

	return (
		<>
		                      {isLoading ? (
  <img
    src={loader}
    alt="Loading..."
    className="loader-gif position-fixed top-50 start-50 translate-middle z-index-5"
  />
) : null}
			<Form className='ClientReportCard'>

				<Row className='mb-1 client-soa-detail-card'>
					<Col lg={2} className="no-pd-card no-right-pad margin-right-11">
						<Card className='mb-1 search-vendor'>
							<Card.Body className="fs--1 vendor-card-body">
								<Flex>
									<div className=" flex-1">
										<Form.Group as={Row} className="" controlId="formPlaintextPassword">
											<Col sm="12">
												<Form.Control id="txtSearchVendor" name="searchVendor" placeholder="Search Client" maxLength={45}
													onChange={(e) => handleClientSearchOnChange(e)}
													onKeyDown={(e) => {
														if (e.key === 'Enter') {
															e.preventDefault();
														}
													}}
												/>
											</Col>
										</Form.Group>
									</div>
								</Flex>
							</Card.Body>
						</Card>
						<Card className="mb-0 client-search-list-card">
							<Card.Header
								as={Flex}
								alignItems="center"
								justifyContent="between"
								className="bg-light"
							>
								<h5 className="mb-0">Clients</h5>
							</Card.Header>
							<Card.Body className='vebdor-card-item p-0 client-search-list-body-card'>
								{clientDetail && clientDetail.map((item, index) => (
									<div
										className="flex-1 border-200 border-top scroll-card-padding"
										key={index}
										style={{
											backgroundColor: clientReportData.clientCode === item.clientCode ? "lightgray" : "transparent",
											padding: "10px 0px",
											margin: "0px 0",
										}}

									>
										<h6 className="mb-0">
											<Link
											className='link-name'
												to=""
												style={{
												
													padding: "5px",
													borderRadius: "5px",
													color: 'black',
													textDecoration: "none"
												}}
												onClick={(e) => {
													e.preventDefault();
													handleFieldChange(e, item.clientCode, "", "Summary", "clientCode");
												}}
											>
												{item.clientName}
											</Link>
										</h6>
									</div>
								))}
							</Card.Body>
						</Card>
					</Col>
					<Col lg={8} className="no-pd-card  no-right-pad ">
						<Card className="mb-1 client-filter-dates">
							<Card.Body className='p5px'>
								<Row className="justify-content">
									<Col className='col-auto no-pd-card'>
									</Col>
									<Col className='col-auto no-pd-card filters'>
										<Form.Group as={Row} controlId="formPlaintextPassword">
											<Form.Label className='col-auto' column>
												From Date
											</Form.Label>
											<Col className='col-auto'>
												<Form.Control type='date' id="dtFromDate" name="fromDate"
													onChange={(e) => handleFieldChange(e)}
													value={Moment(clientReportData.fromDate).format('YYYY-MM-DD') || Moment().format('YYYY-MM-DD')}
												/>
											</Col>
										</Form.Group>
									</Col>
									<Col className='col-auto no-pd-card filters to-date-filter'>
										<Form.Group as={Row} controlId="formPlaintextPassword">
											<Form.Label className='col-auto' column>
												To Date
											</Form.Label>
											<Col className='col-auto'>
												<Form.Control type='date' id="dtToDate" name="toDate"
													onChange={(e) => handleFieldChange(e)}
													value={Moment(clientReportData.toDate).format('YYYY-MM-DD') || Moment().format('YYYY-MM-DD')}
												/>
											</Col>
										</Form.Group>
									</Col>
									<Col className='col-auto no-pd-card filters report-filter'>
										<Form.Group as={Row} controlId="formPlaintextPassword">
											<Form.Label className='col-auto' column>
												Report Type
											</Form.Label>
											<Col lg={3} className="text-end d-flex align-items-center ">

												<Form.Select
													value={clientReportData.reportType}
													name='reportType'
													onChange={(e) => handleFieldChange(e)}
													className="w-auto report-dropdown"
												>
													<option value="Summary">Summary</option>
													<option value="Details">Details</option>
												</Form.Select>
											</Col>
										</Form.Group>
									</Col>
									<Col lg={2} className="text-end d-flex align-items-center text-wrap filters download-filter">
										<Button className="" onClick={() => ClientReportPDF(1, perPage, clientReportData.clientCode, clientReportData.clientCaseNo, clientReportData.reportType, clientReportData.fromDate, clientReportData.toDate)}>Get Report</Button>
									</Col>
								</Row>
							</Card.Body>
						</Card >
						<Col lg={12}>
							<Card className="mb-0 client-search-card">
								<Card.Header
									as={Flex}
									alignItems="center"
									justifyContent="between"
									className="bg-light"
								>
									<h5 className="mb-0">Payments</h5>
								</Card.Header>
								<Card.Body className='vebdor-card-item  client-search-card-body'>
									<div className="">

										{clientReportData.reportType === "Summary" && caseReportCount > 0 && caseReportList.caseReportList ? (
											<Row className="no-padding payment-client-report-card-table">
												<Table striped bordered responsive className="table-md overflow-hidden  ">
													<thead className="custom-bg-200 case-schedule-thead">
														<tr>
															<th>S. No.</th>
															<th>Case No.</th>
															<th>Case Title</th>
															<th>Case Nature</th>
															<th>No. Of Hearing</th>
															<th>Consulting Fees</th>
															<th>Receive Amount</th>
															<th>Balance</th>
														</tr>
													</thead>
													<tbody>
														{caseReportList.caseReportList.map((item, index) => (
															<tr key={index} onClick={(e) => { e.preventDefault(); handleFieldChange(e, item.clientCode, item.caseNo, "Summary", clientReportData.reportType); }}>
																<td>{index + 1}</td>
																<td>{item.caseNo}</td>
																<td>{item.caseTitle}</td>
																<td>{item.caseNo}</td>
																<td >
																	{item.noOFHearing}
																</td>
																<td >
																	{item.consultingFees}
																</td>
																<td>{item.receiveAmount || "0"}</td>
																<td>{item.balance || "0"}</td>
															</tr>
														))}
													</tbody>
												</Table>
											</Row>
										) : (
											<Row className="justify-content-center mt-2">
												<Col className="col-auto">
	
												</Col>
											</Row>
										)}

										{!clientReportData.clientCaseNo && clientReportData.reportType === "Details" && paymentReportList.clientPaymentReportList ? (
											<Row className="no-padding">
											<Table striped bordered responsive className="table-md overflow-hidden payment-client-report-card-table">
												<thead className="custom-bg-200 case-schedule-thead">
													<tr>
														<th>S. No.</th>
														<th>Case No.</th>
														<th>Case Title</th>
														<th>Case Nature</th>
														<th>No. Of Hearing</th>
														<th>Consulting Fees</th>
														<th>Receive Amount</th>
														<th>Balance</th>
													</tr>
												</thead>
												<tbody>
													{caseReportList.caseReportList.map((item, index) => (
														<tr key={index} onClick={(e) => { e.preventDefault(); handleFieldChange(e, item.clientCode, item.caseNo, "Summary", clientReportData.reportType); }}>
															<td>{index + 1}</td>
															<td>{item.caseNo}</td>
															<td>{item.caseTitle}</td>
															<td>{item.caseNo}</td>
															<td >
																{item.noOFHearing}
															</td>
															<td >
																{item.consultingFees}
															</td>
															<td>{item.receiveAmount || "0"}</td>
															<td>{item.balance || "0"}</td>
														</tr>
													))}
												</tbody>
											</Table>
										</Row>
										) : (
											<Row className="justify-content-center mt-2">
												<Col className="col-auto">
													{/* <h4 id="no-case-schedule-message">No payments available</h4> */}
												</Col>
											</Row>
										)}
									</div>

									{clientReportData.clientCaseNo && clientReportData.reportType === "Details" && mergedPaymentAndCaseList && mergedPaymentAndCaseList.length > 0 ?
										<Row className="no-padding">
											<Table striped bordered responsive className="table-md overflow-hidden case-schedule-table">
												<thead className='custom-bg-200 case-schedule-thead'>
													<tr>
														<th>S. No</th>
														<th>Case No.</th>
														<th>Case Title</th>
														<th>Case Nature</th>
														<th>No. of Hearings</th>
														<th>Consulting Fees</th>
														<th>Payment Date</th>
														<th>Amount</th>

													</tr>
												</thead>
												<tbody>
													{mergedPaymentAndCaseList.map((group, groupIndex) => (
														<React.Fragment key={groupIndex}>
															{group.map((item, index) => {
																return (
																	<tr key={`${groupIndex}_${index}`}>
																		{index === 0 && (
																			<>
																				<td rowSpan={group.length}>{groupIndex + 1}</td>
																				<td rowSpan={group.length}>{item.caseNo}</td>
																				<td rowSpan={group.length}>{item.caseTitle}</td>
																				<td rowSpan={group.length}>{item.caseNature}</td>
																				<td rowSpan={group.length}>{item.noOfHearing}</td>
																				<td rowSpan={group.length}>{item.consultingFees}</td>
																			</>
																		)}
																		<td className='p-3'>{Moment(item.paymentDate).format("DD-MMM-YYYY")}</td>
																		<td>{item.amount ? item.amount : ""}</td>

																	</tr>
																);
															})}
														</React.Fragment>
													))}
												</tbody>
											</Table>
										</Row>
										:
										<Row className='justify-content-center mt-2'>
											<Col className='col-auto'>
												<h4 id="no-case-schedule-message"></h4>
											</Col>
										</Row>
									}
											<Row className="PaymentReport-pagination" style={{ position: 'absolute', bottom: '40px', align: 'centre' }}>
													<TablePagination
														pageCount={pageCount}
														handlePageClick={onPageClick}
														pageSize={pageSize}
														handlePageSizeChange={handlePageSize}
														isDisablePrevious={isPreviousDisabled}
														isDisableNext={isNextDisabled}
														previousClick={handlePreviousClick}
														nextClick={handleNextClick}
														pageIndex={pageNumber - 1}
													/>
												</Row>
									<Row className=" totalAmount-card">
										<Col><h4 className='total-text'> Total Amount : <span className='total-amount-text'> {totalAmount != 0 ? totalAmount : 0.00}</span></h4></Col>
									</Row>
								</Card.Body>
							</Card>
						</Col>
					</Col>

					<Col lg={2} className="no-pd-card ps-1 no-right-pad margin-right-11" >
						<Card className='mb-1 search-vendor'>
							<Card.Body className="fs--1 vendor-card-body">
								<Flex>
									<div className=" flex-1">
										<Form.Group as={Row} className="" controlId="formPlaintextPassword">
											<Col sm="12">
												<Form.Control id="txtSearchCaseNo" name="searchClientCase" placeholder="Search Case" maxLength={45}
													onChange={(e) => handleClientCaseSearchOnChange(e)}
													onBlur={() => clientValidation()}
													onKeyDown={(e) => {
														if (e.key === 'Enter') {
															e.preventDefault();
														}
													}}
												/>
											</Col>
										</Form.Group>
									</div>
								</Flex>
							</Card.Body>
						</Card>
						<Card className="mb-0 client-search-list-card ">
							<Card.Header
								as={Flex}
								alignItems="center"
								justifyContent="between"
								className="bg-light"
							>
								<h5 className="mb-0">Cases</h5>
							</Card.Header>
							<Card.Body className='vebdor-card-item p-0 custom-card-scroll'>
								{clientCaseDetail && clientCaseDetail.map((item, index) => (
									<div
										className="flex-1 border-200 border-top scroll-card-padding"
										key={index}
										style={{
											padding: "10px 0px",
											margin: "0px 0",
											backgroundColor: clientReportData.clientCaseNo === item.caseNo ? "lightgray" : "transparent",
										}}
									>
										<h6 className="mb-0">
											<Link to=""
											className='link-name'
												style={{
													backgroundColor: clientReportData.clientCaseNo === item.caseNo ? "lightgray" : "transparent",
													padding: "0px",
													margin:"5px",
													borderRadius: "5px",
													color: 'black',
													textDecoration: "none"
												}}
												onClick={(e) => { e.preventDefault(); handleFieldChange(e, clientReportData.clientCode, item.caseNo, clientReportData.reportType, "clientCaseNo"); }} >
												{`${item.caseNo} - ${item.caseTitle}`}

											</Link>
										</h6>
									</div>
								))}

							</Card.Body>
						</Card>
					</Col>
				</Row>
			</Form>
		</>
	)
}

export default ClientSOADetails